import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'md',
  },
  theme: {
    themes: {
      light: {
        primary: '#C32032',
        secondary: '#002A3A',
        accent: '#037D96',
        error: '#C32032',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#E56703',
        anchor: '#037D96',
      },
    },
  },
});
